import { RoutePlannerOptions } from "src/app/models/map-settings";
import { MapPublicRoute } from "src/dto.generated/api";


export function getSRouteNameForLanguage(route: MapPublicRoute, languageCode: string) {
    let name: string;
    // english
    if (languageCode === "en") { name = route.nameEn; }
    // german
    if (languageCode === "de") { name = route.nameDe; }
    if (!name) { name = route.nameEn; }
    if (!name) { name = route.nameDe; }
    return name;
}
export function getSRouteDescriptionForLanguage(route: MapPublicRoute, languageCode: string) {
    let description: string;
    // english
    if (languageCode === "en") { description = route.descriptionEn; }
    // german
    if (languageCode === "de") { description = route.descriptionDe; }
    if (!description) { description = route.descriptionEn; }
    if (!description) { description = route.descriptionDe; }
    return description;
}

export function getSRoutePlannerOptions(route: MapPublicRoute) {
    if (typeof (route.plannerOptions) === "string") {
        const plannerOptions = JSON.parse(route.plannerOptions);
        return plannerOptions as RoutePlannerOptions;
    };
    return route.plannerOptions;
}


export function getSRouteImageUrl(route: MapPublicRoute) {
    const imageIds = route.imageIds;
    if (imageIds.length === 0) { return ""; }

    const imageId = imageIds[0];
    return imageId;
}


